import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';
import css from './SingpassCallback.css';

const SingpassCallback = props => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const authCode = searchParams.get('code');
  // Myinfo v5 also returns state and iss; v4 returns neither. Both are simply
  // forwarded — the server decides what to do with them from the attempt it
  // started, so this page needs no knowledge of which version ran.
  const state = searchParams.get('state');
  const iss = searchParams.get('iss');

  const history = useHistory();

  useEffect(() => {
    const fetchClientData = async () => {
      try {
        const sessionUserData = JSON.parse(sessionStorage.getItem('CURRENT_USER'));
        const flexUserId = sessionUserData.id.uuid;

        const clientResponse = await axios.post(
          `${process.env.REACT_APP_API_SERVER_URL}/api/singpass/v5/getIndentityPersonData`,
          {
            authCode,
            state,
            iss,
            flexUserId
          }
        );

        // alert('client response should come', clientResponse)
        if (window.ReactNativeWebView) {
          let data = JSON.stringify({
            status: true,
          });
          window.ReactNativeWebView.postMessage(window.location.href);
        } else {
          history.push('/account/driving-verification/singpass-profile');
        }
      } catch (error) {
        if (window.ReactNativeWebView) {
          let data = JSON.stringify({status: false});
          window.ReactNativeWebView.postMessage(window.location.href);
        } else {

          history.push('/account/driving-verification');
        }
      }
    };
    if (authCode) {
      fetchClientData();
    }
  }, [authCode]);

  return (
    <>
      <div className=''>
        <div className={css.loader}></div>
        <h3>We are fetching your verification data from Singpass...</h3>
      </div>

    </>
  );
};

export default SingpassCallback;